import { commentsData } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          瓜友评论
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自吃瓜群众的真实声音</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-[1000px] mx-auto">
          {commentsData.map((comment, i) => (
            <div
              key={i}
              className="p-5 bg-background-100 rounded-xl border border-background-200/70"
            >
              {/* Header */}
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-full flex-shrink-0">
                  <span className="text-background-50 text-sm font-bold">{comment.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>

              {/* Content */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>

              {/* Footer */}
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}